// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__1NPns","col":"styles_col__2MK-G"};